import React from 'react';
import { Create, SimpleForm, ReferenceInput, TextInput, SelectInput, required, minValue, number } from 'react-admin';

const validateShopCategoryCode = [required(), number(), minValue(1)];
const marketplaceRenderer = (marketplace) => `${marketplace.name} (${marketplace.id})`;
const MarketplaceSellerCreate = (props) => (
	<Create {...props}>
		<SimpleForm variant="standard">
			<TextInput source="externalId" validate={required()} />
			<ReferenceInput variant="standard" source="marketplaceId" reference="marketplaces" validate={required()}>
				<SelectInput optionText={marketplaceRenderer} resettable />
			</ReferenceInput>
			<TextInput source="name" validate={required()} />
			<ReferenceInput variant="standard" source="currencyCode" reference="currencies" validate={required()}>
				<SelectInput optionText="name" resettable />
			</ReferenceInput>
			<TextInput source="shopCategoryCode" validate={validateShopCategoryCode} />
			<TextInput source="shopConfigurationName" validate={required()} />
			<TextInput source="shopConfigurationNotificationUrl" />
			<TextInput source="shopConfigurationReturnUrl" />
			<TextInput source="logoUrl" />
		</SimpleForm>
	</Create>
);

export default MarketplaceSellerCreate;
